import tableDragger from 'table-dragger';

export default class TableSorter {
    constructor() {
        this.tables = $('table.sorting-table');


        this.initialize();
    }

    sort() {
        const that = this;

        this.tables.each(function () {
            const table = $(this);
            const callerClass = table.data('class');
            const callerId = table.data('primary-key');

            let dragger = tableDragger(this, {
                mode: 'row',
                dragHandler: '.handle',
                onlyBody: true,
                animation: 300
            });

            dragger.on('drop', function (from, to, element) {
                const rows = table.find('tbody tr');

                let postContent = {
                    callerClass: callerClass,
                    callerId: callerId,
                    rows: []
                }

                rows.each(function (index) {
                    const row = $(this);
                    const fileId = row.data('file-id');
                    const relationClass = row.data('class');
                    const tabName = row.data('tab-name');

                    let rowObject = {
                        sorting: index + 1,
                        fileId: fileId,
                        relationClass: relationClass,
                        tabName: tabName
                    };

                    postContent.rows.push(rowObject);
                });

                $.ajax({
                    type: 'POST',
                    url: '/sortFiles',
                    data: postContent
                }).done(function (result) {

                });
            });
        });

    }

    initialize() {
        this.sort()
    }
}



// WEBPACK FOOTER //
// ./resources/assets/js/plugins/tableSort.js